
import { Button } from "@/components/ui/button";
import { useTranslation } from "react-i18next";
import { useIsMobile } from "@/hooks/use-mobile";
import { useAnalytics } from "@/hooks/use-analytics";

const AboutSection = () => {
  const { t } = useTranslation();
  const isMobile = useIsMobile();
  const { trackProfileAction } = useAnalytics();

  const handleOpenExternalLink = (title: string, url: string) => {
    window.open(url, "_blank", "noopener,noreferrer");
    trackProfileAction('view_profile', 'success', `opened_${title.toLowerCase().replace(/\s+/g, '_')}_external`);
  };

  return (
    <div className="space-y-4">
      <h3 className="text-lg font-semibold">
        {t("settings.about.title")}
      </h3>
      <div className="flex flex-col space-y-2">
        <Button 
          variant="link" 
          className="h-auto p-0 justify-start"
          onClick={() => handleOpenExternalLink(
            t("settings.about.tos"), 
            "https://checkmytrip.com/terms-and-conditions/"
          )}
        >
          {t("settings.about.tos")}
        </Button>
        <Button 
          variant="link" 
          className="h-auto p-0 justify-start"
          onClick={() => handleOpenExternalLink(
            t("settings.about.privacy"), 
            "https://checkmytrip.com/privacy-policy/"
          )}
        >
          {t("settings.about.privacy")}
        </Button>
        <Button 
          variant="link" 
          className="h-auto p-0 justify-start"
          onClick={() => handleOpenExternalLink(
            t("settings.about.faq"),
            "https://checkmytrip.com/frequently-asked-questions/"
          )}
        >
          {t("settings.about.faq")}
        </Button>
      </div>
    </div>
  );
};

export default AboutSection;
